/**
 * Shared Ant Design theme for WordPress admin shells.
 * `colorPrimary` matches WP admin "modern" / default (`wp-admin/css/colors/modern`).
 */ const wpAdminAntdTheme = {
    token: {
        colorPrimary: "#3858e9",
        borderRadius: 3
    },
    components: {
        Select: {
            colorTextPlaceholder: "rgba(0, 0, 0, 0.88)"
        }
    }
};
export { wpAdminAntdTheme };
